import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { HomeComponent } from './components/home/home.component';
import { ContactComponent } from './components/contact/contact.component';
import { MethodsAnalytesComponent } from './components/methods-analytes/methods-analytes.component';
import { LoginComponent } from './components/login/login.component';
// import { RegisterComponent } from './components/register/register.component';
import { UpdateUserComponent } from './components/update-user/update-user.component';
// import { DntCaptchaComponent } from './components/dnt-captcha/dnt-captcha.component';
import { SearchLabsComponent } from './components/searchLabs/searchLabs.component';
import { RegisterLabComponent } from './components/register-lab/register-lab.component';

const COMPONENTS = [
  HomeComponent,
  ContactComponent,
  MethodsAnalytesComponent,
  SearchLabsComponent,
  LoginComponent,
  RegisterLabComponent,
  UpdateUserComponent
  // DntCaptchaComponent
];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
